"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LANGUAGE_MAP_OCC = exports.LOCALE_MAP_OCC = void 0;
exports.LOCALE_MAP_OCC = {
    'en-US': 'aesop-us',
    'en-AU': 'aesop-au',
    'en-NZ': 'aesop-nz',
    'en-SG': 'aesop-sg',
    'en-GB': 'aesop-gb',
    'fr-FR': 'aesop-fr',
    'en-FR': 'aesop-fr',
    'es-FR': 'aesop-fr',
    'en-CA': 'aesop-ca',
    'fr-CA': 'aesop-ca',
    'en-HK': 'aesop-hk',
    'zh-Hant-TW': 'aesop-tw',
    'zh-Hant-HK': 'aesop-hk',
    'de-DE': 'aesop-de',
    'en-DE': 'aesop-de',
    'ja-JP': 'aesop-jp',
    'ko-KR': 'aesop-kr',
    'it-IT': 'aesop-it',
    'en-DK': 'aesop-dk',
    'en-SE': 'aesop-se',
    'en-NO': 'aesop-no',
    'de-CH': 'aesop-ch',
    'fr-CH': 'aesop-ch',
    'en-CH': 'aesop-ch',
};
exports.LANGUAGE_MAP_OCC = {
    'en-US': 'en',
    'en-AU': 'en',
    'en-NZ': 'en',
    'en-SG': 'en',
    'en-GB': 'en',
    'fr-FR': 'fr',
    'es-FR': 'es',
    'en-FR': 'en',
    'en-CA': 'en',
    'fr-CA': 'fr',
    'en-HK': 'en',
    'zh-Hant-TW': 'zh_hant_tw',
    'zh-Hant-HK': 'zh_hant',
    'de-DE': 'de',
    'en-DE': 'en',
    'ja-JP': 'ja',
    'ko-KR': 'ko',
    'it-IT': 'it',
    'en-DK': 'en',
    'en-SE': 'en',
    'en-NO': 'en',
    'de-CH': 'de',
    'fr-CH': 'fr',
    'en-CH': 'en',
};
//# sourceMappingURL=api-occ-v2.js.map